// How long ago something was said, in the form people actually read on a comment: "5 минут
// назад". Russian needs three forms of every unit, picked by the number in front of it, and the
// accusative that "назад" takes ("минуту", not "минута").
const FORMS: Record<string, [string, string, string]> = {
  minute: ["минуту", "минуты", "минут"],
  hour: ["час", "часа", "часов"],
  day: ["день", "дня", "дней"],
  month: ["месяц", "месяца", "месяцев"],
  year: ["год", "года", "лет"],
};

export function plural(n: number, forms: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  // 11-14 take the many-form despite ending in 1-4, which is the rule everyone gets wrong.
  if (mod100 >= 11 && mod100 <= 14) return forms[2];
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export function timeAgo(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  // A clock that is slightly behind the server's shouldn't produce "через минуту".
  const elapsed = Math.max(0, now.getTime() - then);

  if (elapsed < MINUTE) return "только что";
  const [size, unit] =
    elapsed < HOUR
      ? [MINUTE, "minute"]
      : elapsed < DAY
        ? [HOUR, "hour"]
        : elapsed < MONTH
          ? [DAY, "day"]
          : elapsed < YEAR
            ? [MONTH, "month"]
            : [YEAR, "year"];
  const n = Math.floor(elapsed / (size as number));
  return `${n} ${plural(n, FORMS[unit as string])} назад`;
}

// What to call someone on screen: their name when they have one, and otherwise the part of the
// address before the @ -- "d.bedorsyan" reads as a person, the full address does not.
export function displayName(email: string, name?: string | null): string {
  const given = name?.trim();
  if (given) return given;
  const local = email.split("@")[0] ?? email;
  return local || email;
}

export function initials(email: string, name?: string | null): string {
  return (displayName(email, name)[0] ?? "?").toUpperCase();
}
